import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { SNACK_CRITICAL } from '@neslotech/utils';

import { SystemActions } from '../actions/system/system.actions';

import { useAppDispatch, useAuth } from '../hooks';

import AuthenticatedLayout from '../components/layout/authenticated/AuthenticatedLayout';

interface Props {
  children: ReactNode | ReactNode[];
  adminRequired?: boolean;
  // For screens showing other people's HR records (employment contracts,
  // disciplinary documents, payslips, recruitment).  The API enforces this
  // too — without the guard the page still loads, it just renders empty,
  // which reads as a bug rather than as a permission boundary.
  hrPrivilegedRequired?: boolean;
}

const ProtectedRoute = ({
  children,
  adminRequired = false,
  hrPrivilegedRequired = false
}: Props) => {
  const dispatch = useAppDispatch();
  const { token, isAdmin, isHrPrivileged } = useAuth();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (adminRequired && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (hrPrivilegedRequired && !isHrPrivileged) {
    dispatch(SystemActions.addNotice('You are not authorized to view this page!', SNACK_CRITICAL));
    return <Navigate to="/dashboard" replace />;
  }

  return <AuthenticatedLayout>{children}</AuthenticatedLayout>;
};

export default ProtectedRoute;
